// Knowledge › Glossary (A2 step C3): the Latin terms a bot's answers never transliterate (QPay, HbA1c, POS-terminal…).
// No imports on purpose: `node --test` loads this file directly (ui/tests/glossaryView.test.ts).

/** Terms typed by hand: commas or new lines, trimmed, de-duplicated. Casing is kept — HbA1c and HBA1C differ. */
export function parseTermsInput(text: string): string[] {
  const out: string[] = [];
  for (const t of text.split(/[,\n]/)) {
    const term = t.trim();
    if (term && !out.includes(term)) out.push(term);
  }
  return out;
}

export function filterTerms(terms: string[], query: string): string[] {
  const q = query.trim().toLowerCase();
  return q ? terms.filter((t) => t.toLowerCase().includes(q)) : terms;
}

/** Suggestions the glossary does not already hold (exact match — the glossary is case-sensitive). */
export function newSuggestions(suggested: string[], existing: string[]): string[] {
  const have = new Set(existing);
  return suggested.filter((t) => !have.has(t));
}
